import { uaCheck, mq, showAccordion } from "./modules/utils";

uaCheck();


// ================== ハンバーガーメニュー ==================

function headerFnc() {
  if (mq("sp")) {
    $(".toggle-btn").on("click", () => {
      $(".toggle-btn").toggleClass("active");
      $("nav").toggleClass("active");
      $("header h1").toggleClass("active");
    });
    $("nav a").on("click", () => {
      $(".toggle-btn").removeClass("active");
      $("nav").removeClass("active");
      $("header h1").removeClass("active");
    });
  }
}

// ================== グッズJSONデータを取得して処理する関数 ==================

let venueGoodsData = null;

function createGoodsItemHTML(item, eventId = null) {
  const eventQuery = eventId ? `&event_id=${eventId}` : "";
  return `
    <p class="img-box">
      <img src="https://cuepro.office-cue.com/php/image/goods/${item.id}/1_1.jpg" alt="${item.name}">
    </p>
    <div class="goods-item-detail">
      <p class="item-name">${item.name}</p>
      <p class="price">
        ${item.price}<span class="small">円</span><span class="tax">(税込)</span>
      </p>
      <p class="btn">
        <a href="/goods_detail.php?id=${item.id}${eventQuery}">商品詳細</a>
      </p>
    </div>
  `;
}

// 会場ごとのリスト生成
function renderGoodsForVenue(panelEl) {
  const venueKey = panelEl.dataset.venue;
  const goodsList = panelEl.querySelector(".goods-list");
  if (!venueGoodsData || !venueGoodsData[venueKey]) return;

  const { event_id: eventId, items } = venueGoodsData[venueKey];
  goodsList.innerHTML = "";

  items.forEach((item) => {
    const li = document.createElement("li");
    li.innerHTML = createGoodsItemHTML(item, eventId);
    goodsList.appendChild(li);
  });
}

// タブ操作のセットアップ
function setupVenueTabs(container) {
  const tabs = container.querySelectorAll(".venue-tab");
  const panels = container.querySelectorAll(".venue-panel");

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      const { venue } = tab.dataset;

      tabs.forEach((t) => t.classList.remove("is-active"));
      tab.classList.add("is-active");

      panels.forEach((panel) => {
        if (panel.dataset.venue === venue) {
          panel.classList.add("is-active");
          renderGoodsForVenue(panel);
        } else {
          panel.classList.remove("is-active");
        }
      });
    });
  });

  const firstActivePanel = container.querySelector(".venue-panel.is-active");
  if (firstActivePanel) {
    renderGoodsForVenue(firstActivePanel);
  }
}

// 会場切替型処理
async function handleVenueGoods(container) {
  const jsonFile = container.dataset.json;
  if (!jsonFile) return;

  const url = `assets/goodsdata/${jsonFile}`;
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`JSON取得失敗: ${  response.statusText}`);
    venueGoodsData = await response.json();
  } catch (err) {
    console.error("JSON読み込みエラー:", err);
    return;
  }

  setupVenueTabs(container);
}

// 単独型処理
// handleSingleGoodsListの引数にeventIdを追加（デフォルトはnull）
async function handleSingleGoodsList(listEl) {
  const jsonFile = listEl.dataset.json;
  const eventId = listEl.dataset.eventId || null;

  if (!jsonFile) return;

  const url = `assets/goodsdata/${jsonFile}`;
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Fetch失敗: ${response.statusText}`);
    const data = await response.json();
    listEl.innerHTML = "";

    data.forEach((item) => {
      const li = document.createElement("li");
      li.innerHTML = createGoodsItemHTML(item, eventId);
      listEl.appendChild(li);
    });
  } catch (err) {
    console.error("単独JSON取得失敗:", err);
  }
}

async function initGoodsLoader() {
  const venueContainers = document.querySelectorAll(".selectvenue-area[data-json]");
  await Promise.all([...venueContainers].map(container => handleVenueGoods(container)));

  const goodsLists = document.querySelectorAll(".goods-list.is-json[data-json]");
  await Promise.all([...goodsLists].map(listEl => handleSingleGoodsList(listEl)));
}


// ================== スケジュールJSONデータを取得して処理する関数 ==================

// 曜日を取得する関数
const getDayOfWeek = (day, month, year) => ["日", "月", "火", "水", "木", "金", "土"][new Date(`${year}-${month}-${day}`).getDay()];

// 祝日かどうかを確認する関数
const isHoliday = (day, month, year, holidays) => holidays.includes(`${year}-${month}-${day}`);

// 日本語月名から英語月名へのマッピング
const monthMapping = {
  '1': 'January',
  '2': 'February',
  '3': 'March',
  '4': 'April',
  '5': 'May',
  '6': 'June',
  '7': 'July',
  '8': 'August',
  '9': 'September',
  '10': 'October',
  '11': 'November',
  '12': 'December'
};

// テーブル生成関数
function generateScheduleTable(data) {
  const startDate = new Date(data.startDate);
  const monthNumber = (startDate.getMonth() + 1).toString();
  const year = startDate.getFullYear();
  const monthName = monthMapping[monthNumber];

  let tableHtml = `<table><thead><tr><th class="title" colspan="2">${monthNumber}月<span>${monthName}</span></th>`;

  const separatorColumns = data.separatorColumn.map(Number); // JSONから列番号を取得

  const allEventDays = [];
  data.shows.forEach((show) => {
    show.events.forEach((event) => {
      if (!allEventDays.includes(event.day)) {
        allEventDays.push(event.day);
      }
    });
  });

  allEventDays.sort((a, b) => a - b);

  // デイヘッダーの生成
  allEventDays.forEach((day, index) => {
    const separatorClass = separatorColumns.includes(index + 1) ? "separator" : "";
    const dayClass = isHoliday(day, monthNumber, year, data.holidays) ? "sun" : ""; // 祝日の場合、sunクラスを追加
    tableHtml += `<th class="${separatorClass} ${dayClass}">${day}<span>${getDayOfWeek(day, monthNumber, year)}</span></th>`;
  });
  tableHtml += "</tr></thead><tbody>";

  data.shows.forEach((show) => {
    show.times.forEach((time, index) => {
      tableHtml += `<tr>`;
      if (index === 0) {
        tableHtml += `<th rowspan="${show.times.length}" class="title">${show.title}<span>${show.venue}</span></th>`;
      }
      tableHtml += `<th class="time">${time}</th>`;

      allEventDays.forEach((day, dayIndex) => {
        const eventInfo = show.events.find((e) => e.day === day);
        const separatorClass = separatorColumns.includes(dayIndex + 1) ? "separator" : "";
        tableHtml += `<td class="${separatorClass}">${eventInfo && eventInfo.hasEvent[time] ? '<span class="dot"></span>' : ""}</td>`;
      });
      tableHtml += `</tr>`;
    });
  });

  tableHtml += "</tbody></table>";
  return tableHtml;
}

// ページ読み込み時に JSON データを取得してテーブルを生成
async function loadSchedule() {
  const scheduleEl = document.querySelector(".schedule-area[data-json]");
  if (!scheduleEl) return;

  const jsonFile = scheduleEl.dataset.json;
  const jsonUrl = `assets/scheduledata/${jsonFile}`;

  try {
    const data = await $.getJSON(jsonUrl);

    // テーブルを生成して埋め込む
    const tableHtml = generateScheduleTable(data);
    scheduleEl.querySelector(".scroll-table").innerHTML = tableHtml;

    // jQuery で曜日に基づくクラスを追加
    $(".schedule-area table thead th").each(function () {
      const $this = $(this);
      const dayText = $this.text();
      if (dayText.includes("土")) {
        $this.addClass("sat");
      } else if (dayText.includes("日")) {
        $this.addClass("sun");
      }
    });
  } catch (error) {
    console.error("JSONの取得に失敗しました:", error);
  }
}


// ================== グッズの会場タブ切り替え ==================

function venueTabFnc() {
  document.querySelectorAll('.venue-tab').forEach(tab => {
    tab.addEventListener('click', () => {
      const selected = tab.dataset.venue;

      // タブの表示切替
      document.querySelectorAll('.venue-tab').forEach(t => t.classList.remove('is-active'));
      tab.classList.add('is-active');

      // パネルの表示切替
      document.querySelectorAll('.venue-panel').forEach(panel => {
        panel.classList.toggle('is-active', panel.dataset.venue === selected);
      });
    });
  });
}


// ================== 実行 ==================

document.addEventListener("DOMContentLoaded", async () => {
  headerFnc(); // ハンバーガーメニュー
  showAccordion(".faq-list dt"); // FAQアコーディオン
  await initGoodsLoader(); // グッズデータをjsonから取得処理
  loadSchedule(); // スケジュールデータをjsonから取得処理
  venueTabFnc(); // 会場ごとでのタブ切り替え
});
